import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.V6SupplierQuote.';
  public static readonly requestingShopDrawing = `${Id.prefix}requestingShopDrawing`;
  public static readonly requestingSupplierQuote = `${Id.prefix}requestingSupplierQuote`;
  public static readonly createSupplierQuote = `${Id.prefix}createSupplierQuote`;
  public static readonly waitingForSupplierQuoteCreation = `${Id.prefix}waitingForSupplierQuoteCreation`;
  public static readonly exitButton = `${Id.prefix}exitButton`;
  public static readonly unknownErrorCouldNotProduceV6Quote = `${Id.prefix}unknownErrorCouldNotProduceV6Quote`;
  public static readonly v6QuoteNumber = `${Id.prefix}v6QuoteNumber`;
  public static readonly supplierQuoteCreated = `${Id.prefix}supplierQuoteCreated`;
  public static readonly issuingQuote = `${Id.prefix}issuingQuote`;
}

export class LangV6SupplierQuote {
  private constructor() {}
  public static requestingShopDrawing(): string {
    return interpolate(Id.requestingShopDrawing);
  }
  public static requestingSupplierQuote(): string {
    return interpolate(Id.requestingSupplierQuote);
  }
  public static createSupplierQuote(): string {
    return interpolate(Id.createSupplierQuote);
  }
  public static waitingForSupplierQuoteCreation(): string {
    return interpolate(Id.waitingForSupplierQuoteCreation);
  }
  public static exitButton(): string {
    return interpolate(Id.exitButton);
  }
  public static unknownErrorCouldNotProduceV6Quote(): string {
    return interpolate(Id.unknownErrorCouldNotProduceV6Quote);
  }
  public static v6QuoteNumber(params: { fullQuoteNumber: string }): string {
    return interpolate(Id.v6QuoteNumber, params);
  }
  public static supplierQuoteCreated(): string {
    return interpolate(Id.supplierQuoteCreated);
  }
  public static issuingQuote(): string {
    return interpolate(Id.issuingQuote);
  }
}

export class V6SupplierQuoteModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.requestingShopDrawing,
      "Requesting {{glossary 'shopdrawing'}}",
      'Message for requesting shop drawing'
    );
    register.add(
      Id.requestingSupplierQuote,
      "Requesting {{glossary 'supplier'}} {{glossary 'quote'}}",
      'Message for requesting supplier quote'
    );
    register.add(
      Id.createSupplierQuote,
      "Create {{glossary 'supplier'}} {{glossary 'quote'}}",
      'Message for creating supplier quote'
    );
    register.add(
      Id.waitingForSupplierQuoteCreation,
      "Waiting for {{glossary 'supplier'}} {{glossary 'quote'}} creation. This could take time.\nCancelling will not stop the process, but you will not find out the V6 {{glossary 'quote'}} number unless you wait",
      'Message for waiting for supplier quote creation'
    );
    register.add(Id.exitButton, 'Exit', 'Exit button text');
    register.add(
      Id.unknownErrorCouldNotProduceV6Quote,
      'Unknown error. could not produce V6 Quote',
      'Error message for unknown error producing V6 quote'
    );
    register.add(Id.v6QuoteNumber, "V6 {{glossary 'quote'}}: {{fullQuoteNumber}}", 'Message for V6 quote number');
    register.add(
      Id.supplierQuoteCreated,
      "{{glossary 'supplier'}} {{glossary 'quote'}} created",
      'Message for supplier quote created'
    );
    register.add(Id.issuingQuote, "Issuing {{glossary 'quote'}}", 'Message for issuing quote');
  }
}
